import {Injectable} from '@angular/core';
import {Action, State, StateContext, StateToken, Store} from '@ngxs/store';

import {QUERYABLE_STATE_MODEL_DEFAULTS, QueryableState, QueryableStateModel} from '../../../../common/state/queryable.state';
import {QueryBuilder} from "../../../../common/query/query.builder";
import {
  UpdateInventoryDocumentActiveSiderSection,
} from "./inventory-document.actions";

const INVENTORY_DOCUMENT_STATE_TOKEN = new StateToken<InventoryDocumentStateModel>('inventory_document');

export interface InventoryDocumentStateModel extends QueryableStateModel<any> {

}

@State<InventoryDocumentStateModel>({
  name: INVENTORY_DOCUMENT_STATE_TOKEN,
  defaults: {...QUERYABLE_STATE_MODEL_DEFAULTS},
})
@Injectable()
// @ts-ignore
export class InventoryDocumentState extends QueryableState {
  constructor(
    public store: Store,
    public queryBuilder: QueryBuilder,
  ) {
    super(store, queryBuilder);
  }

  // @ts-ignore
  @Action(UpdateInventoryDocumentActiveSiderSection)
  updateInventoryDocumentActiveSiderSection(ctx: StateContext<any>, action: any): void {
    ctx.patchState({
      activeSiderSection: action.name || null
    })
  }
}
